import $ from 'jquery';
import navm from './navm';
import navd from './navd';

navm();
navd($);

export default function () {
  const burgerButton = window.document.querySelector('.c-hamburger');
  const burgerItems = window.document.querySelectorAll('.c-hamburger, .c-hamburger__item');
  const burgerNav = window.document.querySelector('.nav-burger');
  const body = window.document.querySelector('body');
  const crisisMessage = window.document.querySelector('.header__row--1');
  const inverse = [
    '.c-hamburger',
    '.c-hamburger__item',
    '.c-logo__item',
    '.header',
    '.header__row',
    '.header__reserve',
    '.header__reserve-button',
    '.header__burger',
    '.header__link',
    '.top-menu-link',
    '.navp',
    '.navp__apx--title',
    '.navp__apx--revraise',
    '.navp__menu-link',
    '.navp__revraise-button',
  ];
  const tabindexAll = window.document.querySelectorAll('a, button, input');
  const burgerNavTabindexAll = burgerNav.querySelectorAll('a, button, input');

  if (body.classList.contains('corporate-blog') && window.document.querySelector('main booking-layout')) {
    let hasUserInteracted = false;

    window.addEventListener('keydown', () => {
      hasUserInteracted = true;
    }, { once: true, capture: true });
    window.addEventListener('pointerdown', () => {
      hasUserInteracted = true;
    }, { once: true, capture: true });

    window.document.addEventListener('focusin', (event) => {
      if (!hasUserInteracted && event.target === burgerButton) {
        burgerButton.blur();
      }
    }, { once: true });
  }

  /**
   * Inverse header's transparency
   *
   * @param isInverse
   */
  function inverseHeader(isInverse = true) {
    inverse.forEach((selector) => {
      const elem = window.document.querySelectorAll(selector);
      elem.forEach((item) => {
        if (isInverse === true) {
          item.classList.add('inverse');
        } else if (item.classList.contains('scroll')) {
          item.classList.add('inverse');
        } else {
          item.classList.remove('inverse');
        }
      });
    });
  }

  /**
   * Open navigation overlay
   */
  function open() {
    burgerNav.classList.add('open');
    inverseHeader();
    setTimeout(() => {
      burgerNav.classList.add('animate');
    });

    if (crisisMessage) {
      crisisMessage.classList.add('open');
      setTimeout(() => {
        crisisMessage.classList.add('animate');
      });
    }
  }

  /**
   * Close navigation overlay
   */
  function close() {
    burgerNav.classList.remove('animate');
    inverseHeader(false);
    setTimeout(() => {
      burgerNav.classList.remove('open');
    }, 300);

    if (crisisMessage) {
      crisisMessage.classList.remove('animate');
      setTimeout(() => {
        burgerNav.classList.remove('open');
        crisisMessage.classList.remove('open');
      }, 300);
    }
  }

  burgerButton.addEventListener('click', (event) => {
    event.preventDefault();

    burgerButton.setAttribute('disabled', 'disabled');
    setTimeout(() => {
      burgerButton.removeAttribute('disabled');
    }, 300);

    burgerItems.forEach((item) => {
      item.classList.toggle('open');
    });

    body.classList.toggle('overflow-hidden');

    if (burgerButton.classList.contains('open')) {
      open();
    } else {
      close();
    }
  });

  burgerButton.addEventListener('keydown', (event) => {
    const keyCode = event.keyCode || event.which;
    if (keyCode === 13) {
      setTimeout(() => {
        tabindexAll.forEach((element) => {
          if (burgerButton.classList.contains('open') && element !== burgerButton) {
            if (
              element.classList.contains('header__logo')
              || element.classList.contains('header__reserve-button')
              || element.classList.contains('navp__revraise-button')
              || element.classList.contains('reservation-overlay-corporate-open')
            ) {
              return;
            }

            element.setAttribute('tabindex', '-1');
            burgerNavTabindexAll.forEach((item) => {
              item.removeAttribute('tabindex');
            });
          } else {
            element.removeAttribute('tabindex');
          }
        });
      });
      setTimeout(() => {
        burgerButton.focus();
      }, 310);
    }
  });

  const ws = window.screen;
  let ww = 0;

  window.addEventListener('load', () => {
    ww = ws.width;
  });

  window.addEventListener('orientationchange', () => {
    burgerItems.forEach((item) => {
      item.classList.remove('open');
    });

    body.classList.remove('overflow-hidden');

    close();
  });

  window.addEventListener('resize', () => {
    if (ww === ws.width) {
      return;
    }

    burgerItems.forEach((item) => {
      item.classList.remove('open');
    });

    body.classList.remove('overflow-hidden');

    close();
  });
}
